import { createSlice } from '@reduxjs/toolkit';
import * as R from 'ramda';

const initialState = {};

const reducers = {
  resetWaitTimes: R.always(initialState),
};

const { actions, reducer } = createSlice({
  initialState,
  name: 'terminalLocator',
  // eslint-disable-next-line react-hooks/rules-of-hooks
  reducers: R.map(singleReducer => R.flip(R.useWith(singleReducer, [R.prop('payload')])), reducers),
});

export const { resetWaitTimes } = actions;

export default reducer;
